import { Referral } from '@getvim/react-app-infra';

export const convertSpecialty = (specialty?: string): Referral['specialty'] | undefined => {
  if (!specialty) return;

  return {
    description: specialty,
  };
};
